export default "__VITE_ASSET__CXKr6qVn__"